/* unplugin-vue-components disabled */import script from "./lottery.vue?vue&type=script&setup=true&lang=js"
export * from "./lottery.vue?vue&type=script&setup=true&lang=js"

import "./lottery.vue?vue&type=style&index=0&id=223f1d4d&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223f1d4d"]])

export default __exports__